module.exports = __webpack_public_path__ + "static/img/NathanCleary.acfd714.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/NathanCleary.jpg
// module id = ga/+
// module chunks = 0